<script setup></script>

<template>
    <v-btn type="submit" color="primary" variant="elevated">
        <slot>{{ $t('Save') }}</slot>
    </v-btn>
</template>

<style scoped></style>
